import BaseQuery from "@/stateManagement/BaseQuery";
import { singleton } from "tsyringe";

import type { RewardsSpendingRulesState } from "../store/RewardsSpendingRulesStore";
import RewardsSpendingRulesStore from "../store/RewardsSpendingRulesStore";

@singleton()
class RewardsSpendingRulesQuery extends BaseQuery<RewardsSpendingRulesState> {
    constructor(protected store: RewardsSpendingRulesStore) {
        super(store);
    }
    spendingRulesList$ = this.select((state) => state.spendingRulesList);
    status$ = this.select((state) => state.status);
    isLoading$ = this.selectLoading();
}

export default RewardsSpendingRulesQuery;
